import * as React from "react";

export interface DateProviderProps {
  /** Client's timezone */
  timezone?: string;
  /** The children of the component. */
  children?: React.ReactNode;
}

export const DateContext = React.createContext<DateProviderProps>({});

/** Use entire Date Context */
export const useDate = () => React.useContext<DateProviderProps>(DateContext);
